<div class="color-picker-component">
  <div class="color-picker-component-header">
    <span
      class="icon-properties-container"
      (click)="openLayoutBuilder()"
      (keyup.enter)="openLayoutBuilder()"
      tabindex="0"
      aria-label="Open layout"
    >
      <!-- <img src="assets\images\svg\icon_color_picker.svg" alt="color picker"> -->
      <i class="fa fa-th" aria-hidden="true"></i>
    </span>
  </div>
  <p-dialog
    *ngIf="showLayoutBuilder"
    header="{{ dialogHeader }}"
    [(visible)]="showLayoutBuilder"
    [style]="{ width: '75vw', height: '90vh' }"
    [modal]="true"
    appendTo="body"
  >
    <div class="layout-container">
      <div class="divider-mobile-layout position-relative">
        <div class="layout-sub-header">
          {{ 'ADD_FIELDS' | translate }}
        </div>
        <div class="search-form-control field-filter">
          <span class="search-icon">
            <i class="pi pi-search"></i>
          </span>
          <input type="text" class="form-control form-control-sm" placeholder="Search" [(ngModel)]="fieldSearch" />
          <span
            *ngIf="fieldSearch !== '' && fieldSearch !== undefined && fieldSearch !== null"
            class="input-clear-icon"
            (click)="clearFilter('dialog')"
            (keyup.enter)="clearFilter('dialog')"
            tabindex="1"
            aria-label="Clear filter"
            ><img src="assets\images\svg\icon_clear.svg" alt="input clear icon"
          /></span>
        </div>
        <div class="section-table-container mb-2 mt-4">
          <p-table
            [columns]="cols"
            [value]="allFields | uiFilter: fieldSearch : ['label']"
            dataKey="id"
            responsiveLayout="scroll"
            styleClass="p-datatable-sm eva-v2-table-container"
            id="add_key_table"
          >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns">
                  {{ col.header | translate }}
                </th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-table let-columns="columns">
              <tr>
                <td>
                  {{ table.label }}
                </td>
                <td pEditableColumn>
                  <p-checkbox
                    [binary]="true"
                    [(ngModel)]="table.added"
                    [attr.name]="table.added"
                    (onChange)="handleSelectionChange($event, table, 'added')"
                  >
                  </p-checkbox>
                </td>
                <td></td>
              </tr>
              <div *ngIf="isPopupLoader" class="loader">
                <p-progress-spinner></p-progress-spinner>
              </div>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr class="no-records">
                <td colspan="2" class="text-center">
                  {{ 'NO_RECORDS_FOUND' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div *ngIf="isPopupLoader" class="d-flex justify-content-center align-items-center w-100">
          <div class="spinners">
            <p-progress-spinner></p-progress-spinner>
          </div>
        </div>

        <ng-template pTemplate="footer">
          <button type="button" class="btn btn-primary cancel-btn" (click)="closeAddFieldsModalDialogue()">
            {{ 'CANCEL' | translate }}
          </button>
          <button type="button" class="btn btn-primary" (click)="updateFieldsToTable()">
            {{ 'SAVE' | translate }}
          </button>
        </ng-template>
      </div>
      <!-- <div> -->
      <!-- <div > -->
      <vb-layout
        class="grid-layout pl-10"
        [initialData]="layoutdata"
        [layoutOptions]="layoutOptions"
        (updatedCSS)="handleCSSChangeFromGridster($event)"
      ></vb-layout>
      <!-- </div> -->
    </div>

    <!-- </div> -->

    <!-- </div> -->

    <!-- Start -- Hiding Font style changes at field level because it is accompanied at the Template level -->
    <!-- <div class="font-editor-form pt-2" *ngIf="formItems.length">
      <h4>Font Styles</h4>
      <form class="col-6">
        <div [formGroup]="formGroup">
          <div class="form-group row" *ngFor="let control of formItems">
            <label class="col-sm-3 col-form-label">{{control.label}}</label>
            <div class="col-sm-9">
              <vb-font [formControlName]="control.label" [element]="control"></vb-font>
            </div>
          </div>
        </div>
      </form>
    </div> -->
    <!-- End -- Hiding Font style changes at field level because it is accompanied at the Template level -->

    <ng-template pTemplate="footer">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="triggerClickOfGridsterSave()">
        {{ 'SAVE' | translate }}
      </button>
    </ng-template>
  </p-dialog>
</div>
